export default __webpack_public_path__ + "static/media/peanutnovel.5bc0f4ea.png";